import React from "react";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import HistoryIcon from "@mui/icons-material/History";
import { FaTrash } from "react-icons/fa";
const History = ({
  isNewchatbtn,
  newChatStart,
  isfatching,
  filteredToday,
  messageClick,
  handleDeletePopup,
  filteredyesteday,
  oneDay,
  filteredLastweek,
  filteredLastMonth,
}) => {
  
  // console.log("filteredToday",filteredToday)
  // console.log("isfatching",isfatching)
  return (
    <div>
      <div
        style={{
          display: "grid",
          gap: "20px",
          alignItems: "flex-start",
          alignContent: "baseline",
        }}
      >
        <div>
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            style={{
              background: "rgba(211,219,229,0.38)",
              color: "#3d3d3d",
              border: "none",
              boxShadow: "none",
            }}
            disabled={isNewchatbtn}
            onClick={newChatStart}
          >
            New Chat
          </Button>
        </div>

        <div style={{ display: "grid", gap: "10px" }}>
          <div>
            {isfatching && (
              <div style={{ display: "grid", gap: "10px" }}>
                <SkeletonTheme baseColor="#ffffff" highlightColor="#f0f4f9">
                  <p>
                    <Skeleton count={1} height={20} width={100} />
                  </p>
                  <p>
                    <Skeleton count={3} height={50} />
                  </p>
                  <p>
                    <Skeleton count={1} height={20} width={100} />
                  </p>
                  <p>
                    <Skeleton count={4} height={50} />
                  </p>
                </SkeletonTheme>
              </div>
            )}

            {!isfatching && (
              <div id="recentChats">
                {filteredToday && (
                  <div style={{ display: "grid", gap: "10px" }}>
                    <div className="item_history_div">
                      <span
                        style={{
                          fontWeight: "600",
                          fontSize: "16px",
                          paddingBottom: "1rem",
                          display: "block",
                        }}
                      >
                        Today
                      </span>
                      {filteredToday.map((item, index) => (
                        <div
                          id={`history_${item.session_id}`}
                          className="history_item_maincls"
                          key={index}
                        >
                          <div className="recent_history_item">
                            <span>
                              <HistoryIcon
                                sx={{
                                  color: "#0000a0",
                                  paddingTop: "5px",
                                  fontSize: "24px",
                                }}
                              />
                            </span>
                            <span
                              style={{
                                textTransform: "capitalize",
                                display: "grid",
                                gridTemplateColumns: "90% 10%",
                                alignItems: "center",
                                alignContent: "center",
                                width: "100%",
                              }}
                            >
                              <div onClick={() => messageClick(item.session_id)}>
                                <div
                                  className="text_overFlow_new_for_history_question"
                                  style={{ fontWeight: "600" }}
                                >
                                  {item?.first_question}
                                </div>
                                
                              </div>
                              <div>
                                <div>
                                  <FaTrash
                                    className="trashIconnew"
                                    fontSize={12}
                                    onClick={() =>
                                      handleDeletePopup(item.session_id)
                                    }
                                  />
                                </div>
                              </div>
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {filteredyesteday.some(
                  (item) =>
                    new Date(item.createdAt).toDateString() ===
                    new Date(new Date() - oneDay).toDateString()
                ) && (
                  <div style={{ display: "grid", gap: "10px" }}>
                    <div className="item_history_div">
                      <span
                        style={{
                          fontWeight: "600",
                          fontSize: "16px",
                          paddingBottom: "1rem",
                          display: "block",
                          paddingTop: "1.5rem",
                        }}
                      >
                        Yesterday
                      </span>
                      {filteredyesteday.map((item, index) => (
                        <div id={`history_${item.id}`} key={index}>
                          <div className="recent_history_item">
                            <span>
                              <HistoryIcon
                                sx={{
                                  color: "#0000a0",
                                  paddingTop: "5px",
                                  fontSize: "24px",
                                }}
                              />
                            </span>
                            <span
                              style={{
                                textTransform: "capitalize",
                                display: "grid",
                                gridTemplateColumns: "90% 10%",
                                alignItems: "center",
                                alignContent: "center",
                                width: "100%",
                              }}
                            >
                              <div onClick={() => messageClick(item.id)}>
                                <div
                                  className="text_overFlow_new_for_history_question"
                                  style={{ fontWeight: "600" }}
                                >
                                {item?.lastMessage?.text}
                                </div>
                                {/* <div className="text_overFlow_new_for_history">
                                {item?.lastMessage?.text}
                                </div> */}
                              </div>
                              <div>
                                <div>
                                  <FaTrash
                                    className="trashIconnew"
                                    fontSize={12}
                                    onClick={() =>
                                      handleDeletePopup(item.sessionId)
                                    }
                                  />
                                </div>
                              </div>
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {filteredLastweek.some(
                  (item) =>
                    new Date(item.createdAt) >=
                      new Date(new Date() - 7 * oneDay) &&
                    new Date(item.createdAt) <= new Date() - oneDay
                ) && (
                  <div style={{ display: "grid", gap: "10px" }}>
                    <div className="item_history_div">
                      <span
                        style={{
                          fontWeight: "600",
                          fontSize: "16px",
                          paddingBottom: "1rem",
                          display: "block",
                          paddingTop: "1.5rem",
                        }}
                      >
                        Last 7 Days
                      </span>
                      {filteredLastweek.map((item, index) => (
                        <div id={`history_${item.sessionId}`} key={index}>
                          <div className="recent_history_item">
                            <span>
                              <HistoryIcon
                                sx={{
                                  color: "#0000a0",
                                  paddingTop: "5px",
                                  fontSize: "24px",
                                }}
                              />
                            </span>
                            <span
                              style={{
                                textTransform: "capitalize",
                                display: "grid",
                                gridTemplateColumns: "90% 10%",
                                alignItems: "center",
                                alignContent: "center",
                                width: "100%",
                              }}
                            >
                              <div onClick={() => messageClick(item.sessionId)}>
                                <div
                                  className="text_overFlow_new_for_history_question"
                                  style={{ fontWeight: "600" }}
                                >
                                  {item.question}
                                </div>
                                <div className="text_overFlow_new_for_history">
                                  {item.text}
                                </div>
                              </div>
                              <div>
                                <div>
                                  <FaTrash
                                    className="trashIconnew"
                                    fontSize={12}
                                    onClick={() =>
                                      handleDeletePopup(item.sessionId)
                                    }
                                  />
                                </div>
                              </div>
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {filteredLastMonth.some(
                  (item) =>
                    new Date(item.createdAt) >=
                      new Date(new Date() - 30 * oneDay) &&
                    new Date(item.createdAt) <= new Date() - oneDay
                ) && (
                  <div style={{ display: "grid", gap: "10px" }}>
                    <div className="item_history_div">
                      <span
                        style={{
                          fontWeight: "600",
                          fontSize: "16px",
                          paddingBottom: "1rem",
                          display: "block",
                          paddingTop: "1.5rem",
                        }}
                      >
                        Last 30 Days
                      </span>
                      {filteredLastMonth.map((item, index) => (
                        <div id={`history_${item.sessionId}`} key={index}>
                          <div className="recent_history_item">
                            <span>
                              <HistoryIcon
                                sx={{
                                  color: "#0000a0",
                                  paddingTop: "5px",
                                  fontSize: "24px",
                                }}
                              />
                            </span>
                            <span
                              style={{
                                textTransform: "capitalize",
                                display: "grid",
                                gridTemplateColumns: "90% 10%",
                                alignItems: "center",
                                alignContent: "center",
                                width: "100%",
                              }}
                            >
                              <div onClick={() => messageClick(item.sessionId)}>
                                <div
                                  className="text_overFlow_new_for_history_question"
                                  style={{ fontWeight: "600" }}
                                >
                                  {item.question}
                                </div>
                                <div className="text_overFlow_new_for_history">
                                  {item.text}
                                </div>
                              </div>
                              <div>
                                <div>
                                  <FaTrash
                                    className="trashIconnew"
                                    fontSize={12}
                                    onClick={() =>
                                      handleDeletePopup(item.sessionId)
                                    }
                                  />
                                </div>
                              </div>
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default History;
